import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

Vue.use(Vuex);

const auth = {
  username: process.env.VUE_APP_USERNAME,
  password: process.env.VUE_APP_PASSWORD,
};

export default new Vuex.Store({
  state: {
    site: [],
    home: [],
    about: [],
    contact: [],
    policy: [],
    projects: [],
    project: [],
    showCookieWarning: true,
  },
  getters: {
    getPageByUID: (state) => (uid, collection = state.projects) => {
      let i = collection.length;
      while (i--) {
        if (collection[i].uid === uid) {
          return collection[i];
        }
      }
    },
  },
  actions: {
    async loadSite({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "site",
            select: {
              title: true,
              url: true,
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_SITE", response.data.result);
        });
    },
    async loadHome({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('home')",
            select: {
              title: true,
              uid: true,
              about: "page.about_md",
              projects: {
                query: "site.page('projects').children.listed.limit(5)",
                select: {
                  title: true,
                  uid: true,
                  category: true,
                  year: true,
                  client: true,
                  files: {
                    query: "page.files.sortBy('sort').first",
                    select: {
                      url: "file.resize(1200).url",
                      small: "file.resize(800).url",
                      thumb: "file.resize(100).url",
                      orientation: "file.orientation",
                    },
                  },
                },
              },
              clients: {
                query: "site.page('home').clients.toPages",
                select: {
                  title: true,
                  uid: true,
                  client: true,
                },
              },
              images: {
                  query: "page.images.shuffle.first",
                  select: {
                    url: "file.url",
                    srcset: "file.srcset([400, 800, 1200, 1600, 2000])"
                  },
            },
              files: {
                query: "page.files",
                select: {
                  url: "file.url",
                },
              },
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_HOME", response.data.result);
        });
    },
    async loadAbout({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('about')",
            select: {
              title: true,
              uid: true,
              description: "page.about_md",
              video: {
                query: "page.videos.first",
                select: {
                  url: "file.url",
                },
              },
              sections: {
                query: "page.indhold.toStructure",
                select: {
                  type: true,
                  text: "structureItem.text.kirbytext",
                  small: "structureItem.small.kirbytext",
                  image: {
                    query: "structureItem.image.toFile",
                    select: {
                      url: "file.url",
                    },
                  },
                },
              },
              clients: "page.clients_md.kirbytext",
              image: "page.images.first.url",
              contact: "page.contact_md.kirbytext",
              imprint: "page.impressum_md.kirbytext",
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_ABOUT", response.data.result);
        });
    },
    async loadContact({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('contact')",
            select: {
              title: true,
              uid: true,
              text: "page.contact_md.kirbytext",
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_CONTACT", response.data.result);
        });
    },
    async loadPolicy({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('policy')",
            select: {
              title: true,
              uid: true,
              text: "page.text.kirbytext",
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_POLICY", response.data.result);
        });
    },
    async loadProjects({ commit }) {
      await axios
        .post(
          "/api/query",
          {
            query: "page('projects').children.listed",
            select: {
              title: true,
              uid: true,
              category: true,
              year: true,
              files: {
                query: "page.images.sortBy('sort').first",
                select: {
                  url: "file.resize(1200).url",
                  small: "file.resize(600).url",
                  thumb: "file.resize(100).url",
                  orientation: "file.orientation",
                  ratio: "file.ratio",
                },
              },
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_PROJECTS", response.data.result.data);
        });
    },
    async loadProject({ commit }, uid) {
      await axios
        .post(
          "/api/query",
          {
            query: `page('projects').children.find('${uid}')`,
            select: {
              title: true,
              uid: true,
              category: true,
              year: true,
              client: true,
              description: "page.description_md.kirbytext",
              credit: "page.credit_md",
              cover: {
                  query: "page.intro.toFile",
                  select: {
                        url: "file.resize(1200).url",
                        small: "file.resize(600).url",
                        thumb: "file.resize(100).url",
                        orientation: "file.orientation",
                  }
              },
              content: {
                query: "page.contents.toStructure",
                select: {
                  type: "structureItem.type",
                  text: "structureItem.text.kirbytext",
                  gallery: {
                    query: "structureItem.gallery.toFiles",
                    select: {
                      url: "file.resize(1200).url",
                      small: "file.resize(600).url",
                      thumb: "file.resize(100).url",
                      orientation: "file.orientation",
                    },
                  },
                  video: {
                    query: "structureItem.video.toFile",
                    select: {
                      url: "file.url",
                    },
                  },
                },
              },
            },
          },
          {
            auth,
          }
        )
        .then(function (response) {
          commit("SET_PROJECT", response.data.result);
        });
    },
  },
  mutations: {
    SET_SITE(state, site) {
      state.site = site;
    },
    SET_HOME(state, home) {
      state.home = home;
    },
    SET_ABOUT(state, about) {
      state.about = about;
    },
    SET_CONTACT(state, contact) {
      state.contact = contact;
    },
    SET_POLICY(state, policy) {
      state.policy = policy;
    },
    SET_PROJECTS(state, pages) {
      state.projects = pages;
    },
    SET_PROJECT(state, pages) {
      state.project = pages;
    },
  },
});
